import React from 'react';
import { styles } from './ProductsTab.css';

export type ProductsTabProps = {
  children: React.ReactNode;
};

export const ProductsTab = ({ children }: ProductsTabProps) => {
  return <div className={styles.productTabContainer}>{children}</div>;
};
